/**
 * Clasificación de errores de push para la cola de sync (módulo PURO:
 * compartido entre la app y el Service Worker, igual que syncBatcher/syncFields).
 *
 * Un rechazo de RLS (permisos) es determinístico: reintentarlo no lo va a
 * arreglar nunca. Para esos casos el pending se marca RECHAZADO de inmediato —
 * sin agotar los MAX_PUSH_RETRIES — y queda retenido en la cola (nunca se
 * borra) a la espera de intervención manual. La cola de reintentos queda así
 * reservada para lo offline/transitorio, y la UI puede avisarle al usuario
 * que su cambio fue rechazado en vez de silenciarlo como CONFLICTO.
 */

/** Prefijo durable en `lastError` de los pendientes rechazados por permisos. */
export const RECHAZADO_PERMISOS_PREFIX = 'RECHAZADO (permisos): ';

/**
 * ¿El error es un rechazo de RLS/permisos de Postgres/PostgREST?
 *
 * Formas que toma: `new row violates row-level security policy for table "..."`
 * (INSERT/UPDATE, código 42501) y `permission denied for table "..."`.
 */
export function esErrorPermisos(message?: string | null): boolean {
  if (!message) return false;
  const m = message.toLowerCase();
  return (
    m.includes('row-level security') ||
    m.includes('42501') ||
    m.includes('permission denied')
  );
}

/** ¿El pending ya está marcado como rechazado por permisos? (para no re-enviarlo) */
export function esRechazadoPorPermisos(lastError?: string | null): boolean {
  return !!lastError && lastError.startsWith(RECHAZADO_PERMISOS_PREFIX);
}

/** Mensaje durable para marcar un pending rechazado por permisos. */
export function mensajeRechazadoPermisos(error: string): string {
  return `${RECHAZADO_PERMISOS_PREFIX}${error}`;
}
